import React, { useState, useEffect }  from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
// ****** DataTable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
// Bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';
//
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const AsignacionCostoHora = ({usuario, apiUrl}) => {
    const [usuarios, setUsuarios] = useState([]);
    const [costoHora, setCostoHora] = useState(0);
    // Modal
    const [idUsuarioSelected, setIdUsuarioSelected] = useState("");
    const [idPersonaSelected, setIdPersonaSelected] = useState("");
    const [nombreSelected, setNombreSelected] = useState("");
    const [puestoSelected, setPuestoSelected] = useState("");
    const [costoHoraSelected, setCostoHoraSelected] = useState(0);
    
    // Para datatable
    const columns = [
        { data: 'IDUSUARIO', className: 'dt-center', width: "10%"},
        { data: 'NOMBREUSUARIO', className: 'dt-center', width: "40%"},
        { data: 'PUESTO', className: 'dt-center', width: "40%"},
        { data: 'COSTO_HORA', className: 'dt-center', width: "10%"},
        { title: 'OPCIONES'},
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_',
        infoFiltered: '(filtrados de un total de _MAX_ colaboradores encontrados)',
        lengthMenu: 'Mostrando _MENU_ colaboradores por página',
        zeroRecords: 'Cero colaboradores encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron colaboradores',
        emptyTable: 'Tabla vacía (sin colaboradores)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        language: languageOpt,
        responsive: true
    };

    const obtenUsuarios = () => {
        axios.post(`${apiUrl}/usuario/usuariosDepartamento?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setUsuarios(objResponse.data.response);
            })
            .catch((error) => {
                alert('hubo un error al recuperar los usuarios: ' + error.response.data)
            });
    }

    const actualizarCostoHora = () => {
        axios.post(`${apiUrl}/usuario/actualizarCostoHora?token=${sessionStorage.getItem('token')}`, 
            {
                IDUSUARIO: idUsuarioSelected,
                costo_hora: costoHora, 
                IDUSUARIOMODIFICACION: usuario.IDUSUARIO
            }
            )
            .then((objResponse) => {
                setCostoHora(0);
                setShowModal(false);
                obtenUsuarios();
            })
            .catch((error) => {
                alert('hubo un error al actualizar el costo de la hora: ' + error.response.data)
            });
    }

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = (IDUSUARIO, IDPERSONA, NOMBREUSUARIO, PUESTO, COSTO_HORA) => {
        setIdUsuarioSelected(IDUSUARIO);
        setIdPersonaSelected(IDPERSONA)
        setNombreSelected(NOMBREUSUARIO);
        setPuestoSelected(PUESTO);
        setCostoHoraSelected(COSTO_HORA);
        setShowModal(true);
    }

    useEffect(()=>{
        obtenUsuarios();
    }, []);

    return (
        <div>
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Está a punto de actualizar el costo - hora del colaborador
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive>
                        <thead>
                            <tr>
                                <th colSpan={2} style={{textAlign: 'center'}}>Información colaborador</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Número de empleado</td>
                                <td>{idUsuarioSelected}</td>
                            </tr>
                            <tr>
                                <td>Nombre colaborador</td>
                                <td>{nombreSelected}</td>
                            </tr>
                            <tr>
                                <td>Puesto</td>
                                <td>{puestoSelected}</td>
                            </tr>
                            <tr>
                                <td>Costo por hora</td>
                                <td>{costoHoraSelected}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Form.Label>Costo x hora</Form.Label>
                    <Form.Control type='number' value={costoHora} onChange={(event) => {setCostoHora(event.target.value) }}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button variant='primary' onClick={actualizarCostoHora}>
                        Guardar costo
                    </Button>
                </Modal.Footer>
            </Modal>
            <Container>
                <Row>
                    <Col><h3 style={{textAlign: 'center'}}>Asignar costo hora de colaborador</h3></Col>
                </Row>
                <Row style={{marginTop: '1em', textAlign: 'center'}}>
                    <Col>
                        <DataTable
                            columns={columns} 
                            data={usuarios}  
                            className="display"
                            options={options}
                            responsive={true}
                            slots={{
                                4: (data, row) => (
                                    <div>
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Editar </strong> costo hora del colaborador.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn btn-success btn-sm bi bi-cash-coin"
                                                style={{marginRight: '1em'}}
                                                onClick={ () => {
                                                    handleShowModal(row.IDUSUARIO, row.IDPERSONA, row.NOMBREUSUARIO, row.PUESTO, row.COSTO_HORA);
                                                }}
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                )
                            }}
                            >
                            <thead >
                                <tr>
                                    <th /* className="dt-orderable-asc" */ style= {{textAlign: 'center'}}>IDUSUARIO</th>
                                    <th style= {{textAlign: 'center'}}>NOMBRE</th>
                                    <th style= {{textAlign: 'center'}}>PUESTO</th>
                                    <th style= {{textAlign: 'center'}}>COSTO HORA</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AsignacionCostoHora;